import { CompanyAccount } from '@treasury/domain/company/company-account.entity';
import { StopPayment } from '@treasury/domain/stop-payments';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/layout/tm-section';
import '@treasury/presentation/components/tm-footer';
import { ButtonConfig } from '@treasury/presentation/components/tm-footer.types';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './editable-stop-payment.template';

export const tagName = 'stop-payment-create-step';
@customElement(tagName)
export class StopPaymentCreateStep extends TmBaseComponent {
    @property({ type: Object })
    public stopPayment!: StopPayment;

    @property({ type: Array })
    public accounts: CompanyAccount[] = [];

    @property({ type: Boolean })
    public isEdit = false;

    @state()
    private isValid = false;

    protected render() {
        return html`
            <tm-section class="pb-3 mb-3 h-max"
                ><editable-stop-payment
                    .stopPayment=${this.stopPayment}
                    .accounts=${this.accounts}
                    @update=${(e: CustomEvent) => {
                        this.stopPayment = e.detail;
                        this.isValid = !!this.stopPayment.isValid();
                    }}
                ></editable-stop-payment>
            </tm-section>
            ${this.renderFooter()}
        `;
    }

    protected renderFooter() {
        const buttons: ButtonConfig[] = [
            {
                text: this.isEdit ? 'Update' : 'Review',
                disabled: !this.isValid,
                onClick: () =>
                    this.dispatchEvent(
                        new CustomEvent('create', { bubbles: true, composed: true })
                    ),
            },
        ];
        return html`<tm-footer .buttonConfig=${buttons}></tm-footer>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: calc(100vh + 150px);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: StopPaymentCreateStep;
    }
}
